import { type MutableRefObject, createContext, useContext } from 'react';

type CPPContext = {
  unreactiveNoteValue: MutableRefObject<string | undefined>;
};

// Inert default: consumers rendered outside the Provider would otherwise share
// (and overwrite) one module-level note ref across every patient in the app.
// Reads always give `undefined` and writes are dropped instead of throwing.
const CPPContext = createContext<CPPContext>(
  Object.freeze({
    unreactiveNoteValue: Object.freeze({
      get current(): string | undefined {
        return undefined;
      },
      set current(_value: string | undefined) {
        // no-op outside the Provider
      },
    }),
  }),
);

export const useCPPContext = () => useContext(CPPContext);

export default CPPContext;
